import { TRUSTPILOT_SUPPORTED_LANGUAGES } from "~~/constants/trustPilot";

export default function () {

  const { language } = useLocalization();

  const showTrustPilotWidget = computed(() => language.value &&
    TRUSTPILOT_SUPPORTED_LANGUAGES.includes(language.value),
  );

  return {
    showTrustPilotWidget,
  };

}
